import { VisitObjective } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface VisitObjectiveInput {
  title: string;
}

export const visitObjectiveService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<VisitObjective>>(
      "/visit_objective",
      {
        params: {
          page,
          per_page,
          search,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<VisitObjective, false>>(
      `/visit_objective/${id}`,
    );
    return response.data;
  },

  async create(data: VisitObjectiveInput) {
    const response = await api.post("/visit_objective", data);
    return response.data;
  },

  async update(id: number | string, data: VisitObjectiveInput) {
    const response = await api.put(`/visit_objective/${id}`, data);
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/visit_objective/${id}`);
    return response.data;
  },
};
